import jsonpPromise from 'jsonp-promise';
import qs from './query-string-util';
import wrapAfterServicePromise from '@src/utils/wrap-after-service-promise';
import constants from '@src/constants';

/**
 * jsonp 请求
 * @param {string} url - 请求地址
 * @param {object} params - 请求参数
 * @param {boolean} useRawResponse - 使用原始的 response
 * @returns {Promise<ServiceResponse>}
 */
function jsonp(url, params = {}, { useRawResponse } = {}) {
  const requestOptions = { url, params };
  return wrapAfterServicePromise(
    () => {
      // 使用 __ts__ 确保请求不会被各种原因缓存
      params = Object.assign(
        {},
        {
          /*__ts__: +new Date(),*/ session_id: localStorage.getItem('SESSION_ID') || undefined
        },
        params
      );
      return jsonpPromise(url + '?' + qs.stringify(params), {
        // 明确命名空间
        prefix: '__xfe',
        // 保证在 mock 开启时不超时
        timeout: constants.IS_MOCK_ON ? 9999999 : undefined
      }).promise;

      promise.then(response => {
        if (response.data && response.data.session_id) {
          localStorage.setItem('SESSION_ID', response.data.session_id);
        }
      });

      return promise;
    },
    { requestOptions, useRawResponse }
  );
}

jsonp.customWrap = async (url, params) => {
  const serviceResponse = await jsonp(url, params);
  if (serviceResponse.isSuccess()) {
    return serviceResponse.data;
  } else {
    return Promise.reject(serviceResponse);
  }
};

export default jsonp;
